import { Component, Injector } from '@angular/core';
import type { OnInit, OnDestroy } from '@angular/core';
import { NgForm } from '@angular/forms'
import { ActivatedRoute } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

import { RadioModalPage } from '@shared/pages';
import { ServiceAreasService, FirebazeStorageService } from '@shared/services';
import { ViewBasePage } from '@shared/pages';
import { Constants } from '@shared/models';
import type { TRegionDocument, TServiceArea  /*, TZipcodes */ } from '@shared/models';

@Component({
    'selector': 'app-serviceAreaSingle',
    'templateUrl': './serviceAreaSingle.page.html',
    'styleUrls': ['./serviceAreaSingle.page.scss'],
    'standalone': true,
    'imports': [ CommonModule, FormsModule, IonicModule ]
})
export class ServiceAreaSinglePage extends ViewBasePage implements OnInit, OnDestroy {
    private uid = '';
    private dealershipcoordinate;
    private dealershipStatecode: string;
    public area: TServiceArea = {
        zipcode: '',
        city: '',
        distance: 0,
        regionCode: '',
        regionName: ''
    };
    public saveAttempt = false;
    public submitted = false;
    private regionName: string;
    private regionInfo: TRegionDocument;     //  TZipcodes;

    constructor(private activatedRoute: ActivatedRoute, private serviceAreasService: ServiceAreasService,
        private firebazeStorageService: FirebazeStorageService,
        injector: Injector) {
        super(injector);
    }

    public ionViewWillEnter(): void {
        super.setCurrentView(this.Constants.VIEW_SERVICE_AREAS_SINGLE);
    }

    public override  async ngOnInit(): Promise<void> {
        super.ngOnInit();

        const dealership = this.sessionService.getDealership();
        this.dealershipcoordinate = dealership.address.coordinate;
        this.dealershipStatecode = dealership.address.regionCode;
        this.area.regionName = dealership.address.regionName;

        await this.uxHelperService.showSpinner();
        await this.onStateChange(this.dealershipStatecode);

        this.uid = this.activatedRoute.snapshot.paramMap.get('uid') ?? '';
        if (this.uid) {
            this.area = await this.serviceAreasService.getByUid(this.uid);
        }
        await this.uxHelperService.hideSpinner();
        // this.initMoreMenu();
    }

    public override ngOnDestroy(): void {
        super.ngOnDestroy();
    }

    // public initMoreMenu(): void {
    //     this.resetPopoverMenu();
    //     this.pushPopoverMenuItem('Show Tour', 'show-service-area-single-tour');
    // }

    public async onStateClick(): Promise<void> {
        const items = Constants.US_STATES.map(x => x.regionName);

        // const items2 = Constants.US_STATES.map(m => m.regionName);
        // if (items === items2) {
        //     found;
        // }

        const options: any = {
            component: RadioModalPage,
            componentProps: { 'items': items, 'selectedItem': this.regionName, 'title': 'Select State / Region' },
            backdropDismiss: false,
            showBackdrop: true,
            cssClass: 'serviceAreaSingleRadioModal'
        };

        const myModal = await this.modalController.create(options);
        await myModal.present();
        const response: any = await myModal.onDidDismiss();
        if (response.data.okay) {
            const item = Constants.US_STATES.filter((regionInfo) => (regionInfo.regionName === response.data.selectedItem));
            if (item[0].regionCode) {
                this.onStateChange(item[0].regionCode);
            }
        }
    }

    public async onStateChange(regionCode: string): Promise<void> {
        await this.uxHelperService.showSpinner();
        this.regionInfo = await this.firebazeStorageService.getRegionDocument(regionCode);
        this.area.regionName = this.regionInfo.state;
        this.area.regionCode = this.regionInfo.statecode;
        this.area.city = '';
        this.area.distance = 0;
        this.area.zipcode = '';
        await this.uxHelperService.hideSpinner();
    }

    // If the user doesn't supply the city or distance, supply them.
    public async onZipcodeChange() {
        if (this.area.zipcode.length === 5) {
            try {
                // console.log('this.area.zipcode:', this.area.zipcode);
                // console.log('this.regionInfo:', this.regionInfo);
                const zipInfo = this.regionInfo.zipcodes.find(zip => (zip.zipcode === this.area.zipcode));

                if (zipInfo) {
                    this.area.city = zipInfo.city;
                    const obj = this.utilsService.calculateDistance(zipInfo.coordinate, this.dealershipcoordinate);
                    this.area.distance = obj.miles;
                } else {
                    const msg = this.area.zipcode + ':  Zipcode not found in this state: ' + this.area.regionName;
                    await this.uxHelperService.showAlert('Error', msg);
                }
            } catch (err) {
                const errorMessage = this.utilsService.extractError(err);
                await this.uxHelperService.showAlert('Error', errorMessage);
            }
        }
    }

    public async onSaveClick(form: NgForm) {
        this.submitted = true;
        if (!form.valid) {
            return;
        }

        try {
            await this.uxHelperService.showSpinner('Saving.');
            if (this.uid) {
                await this.serviceAreasService.update(this.area);
            } else {
                await this.serviceAreasService.set(this.area);
            }
            await this.uxHelperService.hideSpinner();
            this.uxHelperService.showToast('Saved.');
        } catch (err) {
            await this.uxHelperService.hideSpinner();
            const errorMessage = this.utilsService.extractError(err);
            await this.uxHelperService.showAlert('Error:', errorMessage);
        } finally {
            await this.uxHelperService.hideSpinner();
            this.router.navigateByUrl('/managerSettings/serviceAreas');
        }
    }
}
